import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Title from "../ReusableComponents/title";
import "../../assets/css/accountmetrics.scss";
import { createSvgIcon, Grid } from "@mui/material";
import HeadAndDesc from "../ReusableComponents/HeadAndDesc";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { dollarUS, formatDate } from "../../utilities/formatters";

const CopyFormatter = (data) => {
  const [copied, setCopied] = useState(false);

  const onCopyText = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div className="CopyItem d-flex gapp-10 align-items-center">
      <div>{data}</div>
      <CopyToClipboard text={data} onCopy={onCopyText}>
        <span>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.49992 0.708496C2.85355 0.708496 0.708252 2.8538 0.708252 5.50016V11.4226C0.708252 11.7677 0.988074 12.0476 1.33325 12.0476C1.67843 12.0476 1.95825 11.7677 1.95825 11.4226V5.50016C1.95825 3.54415 3.54391 1.9585 5.49992 1.9585H11.344C11.6891 1.9585 11.969 1.67867 11.969 1.3335C11.969 0.988318 11.6891 0.708496 11.344 0.708496H5.49992Z"
              fill="white"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.3354 3.66121C10.6346 3.35936 7.86528 3.35936 5.16448 3.66121C4.39509 3.7472 3.77681 4.3527 3.68612 5.12806C3.3658 7.86679 3.3658 10.6335 3.68612 13.3723C3.77681 14.1476 4.39509 14.7531 5.16448 14.8391C7.86528 15.141 10.6346 15.141 13.3354 14.8391C14.1048 14.7531 14.7231 14.1476 14.8137 13.3723C15.1341 10.6335 15.1341 7.86679 14.8137 5.12806C14.7231 4.3527 14.1048 3.7472 13.3354 3.66121ZM5.30333 4.90348C7.91184 4.61194 10.588 4.61194 13.1965 4.90348C13.3943 4.92558 13.5498 5.08201 13.5722 5.27327C13.8812 7.91552 13.8812 10.5848 13.5722 13.2271C13.5498 13.4183 13.3943 13.5747 13.1965 13.5968C10.588 13.8884 7.91185 13.8884 5.30333 13.5968C5.10553 13.5747 4.95003 13.4183 4.92766 13.227C4.61862 10.5848 4.61862 7.91552 4.92766 5.27327C4.95003 5.08201 5.10553 4.92558 5.30333 4.90348Z"
              fill="white"
            />
          </svg>
        </span>
      </CopyToClipboard>
      {copied ? (
        <span
          className="CopiedText"
          style={{
            color: "#04D9FF",
            position: "absolute",
            bottom: "-10px",
            right: "0px",
          }}
        >
          Copied!
        </span>
      ) : null}
    </div>
  );
};

const PasswordFormatter = (data) => {
  const [show, setShow] = useState(false);

  const ShowPassword = createSvgIcon(
    <svg
      width="20"
      height="14"
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 7C6.25 4.92893 7.92893 3.25 10 3.25C12.0711 3.25 13.75 4.92893 13.75 7C13.75 9.07107 12.0711 10.75 10 10.75C7.92893 10.75 6.25 9.07107 6.25 7ZM10 4.75C8.75736 4.75 7.75 5.75736 7.75 7C7.75 8.24264 8.75736 9.25 10 9.25C11.2426 9.25 12.25 8.24264 12.25 7C12.25 5.75736 11.2426 4.75 10 4.75Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.32343 5.64635C1.90431 6.25029 1.75 6.7227 1.75 7C1.75 7.2773 1.90431 7.74971 2.32343 8.35365C2.72857 8.93744 3.33078 9.57028 4.09267 10.155C5.61978 11.3271 7.71345 12.25 10 12.25C12.2865 12.25 14.3802 11.3271 15.9073 10.155C16.6692 9.57028 17.2714 8.93744 17.6766 8.35365C18.0957 7.74971 18.25 7.2773 18.25 7C18.25 6.7227 18.0957 6.25029 17.6766 5.64635C17.2714 5.06256 16.6692 4.42972 15.9073 3.84497C14.3802 2.67292 12.2865 1.75 10 1.75C7.71345 1.75 5.61978 2.67292 4.09267 3.84497C3.33078 4.42972 2.72857 5.06256 2.32343 5.64635ZM3.17941 2.65503C4.90965 1.32708 7.31598 0.25 10 0.25C12.684 0.25 15.0903 1.32708 16.8206 2.65503C17.6874 3.32028 18.4032 4.06244 18.9089 4.79115C19.4006 5.49971 19.75 6.2773 19.75 7C19.75 7.7227 19.4006 8.50029 18.9089 9.20885C18.4032 9.93756 17.6874 10.6797 16.8206 11.345C15.0903 12.6729 12.684 13.75 10 13.75C7.31598 13.75 4.90965 12.6729 3.17941 11.345C2.31262 10.6797 1.59681 9.93756 1.0911 9.20885C0.599371 8.50029 0.25 7.7227 0.25 7C0.25 6.2773 0.599371 5.49971 1.0911 4.79115C1.59681 4.06244 2.31262 3.32028 3.17941 2.65503Z"
        fill="white"
      />
    </svg>,
    "Home"
  );

  const HidePassword = createSvgIcon(
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5303 1.53033C18.8232 1.23744 18.8232 0.762563 18.5303 0.46967C18.2374 0.176777 17.7626 0.176777 17.4697 0.46967L1.46967 16.4697C1.17678 16.7626 1.17678 17.2374 1.46967 17.5303C1.76256 17.8232 2.23744 17.8232 2.53033 17.5303L5.37723 14.6834C6.74353 15.3266 8.31719 15.75 10 15.75C12.684 15.75 15.0903 14.6729 16.8206 13.345C17.6874 12.6797 18.4032 11.9376 18.9089 11.2089C19.4006 10.5003 19.75 9.7227 19.75 9C19.75 8.2773 19.4006 7.49971 18.9089 6.79115C18.4032 6.06244 17.6874 5.32028 16.8206 4.65503C16.5585 4.45385 16.2808 4.25842 15.989 4.07163L18.5303 1.53033ZM14.8995 5.16113L13.1287 6.93196C13.5213 7.52478 13.75 8.23569 13.75 9C13.75 11.0711 12.0711 12.75 10 12.75C9.23569 12.75 8.52478 12.5213 7.93196 12.1287L6.51524 13.5454C7.58077 13.9795 8.76212 14.25 10 14.25C12.2865 14.25 14.3802 13.3271 15.9073 12.155C16.6692 11.5703 17.2714 10.9374 17.6766 10.3536C18.0957 9.74971 18.25 9.2773 18.25 9C18.25 8.7227 18.0957 8.25029 17.6766 7.64635C17.2714 7.06256 16.6692 6.42972 15.9073 5.84497C15.5941 5.60461 15.2571 5.37472 14.8995 5.16113ZM9.02994 11.0307C9.32366 11.1713 9.65264 11.25 10 11.25C11.2426 11.25 12.25 10.2426 12.25 9C12.25 8.65264 12.1713 8.32366 12.0307 8.02994L9.02994 11.0307Z"
        fill="white"
      />
      <path
        d="M10 2.25C11.0323 2.25 12.0236 2.40934 12.9511 2.68101C13.1296 2.73328 13.1827 2.95662 13.0513 3.0881L12.2267 3.91265C12.1648 3.97451 12.0752 3.99928 11.99 3.97967C11.3506 3.83257 10.6839 3.75 10 3.75C7.71345 3.75 5.61978 4.67292 4.09267 5.84497C3.33078 6.42972 2.72857 7.06256 2.32343 7.64635C1.90431 8.25029 1.75 8.7227 1.75 9C1.75 9.2773 1.90431 9.74971 2.32343 10.3536C2.67725 10.8635 3.18138 11.4107 3.81091 11.9307C3.92677 12.0264 3.93781 12.2015 3.83156 12.3078L3.12265 13.0167C3.03234 13.107 2.88823 13.1149 2.79037 13.0329C2.09739 12.4517 1.51902 11.8255 1.0911 11.2089C0.599371 10.5003 0.25 9.7227 0.25 9C0.25 8.2773 0.599371 7.49971 1.0911 6.79115C1.59681 6.06244 2.31262 5.32028 3.17941 4.65503C4.90965 3.32708 7.31598 2.25 10 2.25Z"
        fill="white"
      />
      <path
        d="M10 5.25C10.1185 5.25 10.2357 5.25549 10.3513 5.26624C10.5482 5.28453 10.6194 5.51991 10.4796 5.6597L9.26739 6.87196C8.61408 7.09683 8.09683 7.61408 7.87196 8.26739L6.6597 9.47965C6.51991 9.61945 6.28453 9.54818 6.26624 9.35132C6.25549 9.23566 6.25 9.11847 6.25 9C6.25 6.92893 7.92893 5.25 10 5.25Z"
        fill="white"
      />
    </svg>
  );

  const handlePasswordClick = () => {
    setShow(!show);
  };

  return (
    <div className="CopyItem d-flex gapp-10 align-items-center">
      <div>{show ? data : "* * * * * * * *"}</div>
      {show ? (
        <HidePassword onClick={handlePasswordClick} edge="end" />
      ) : (
        <ShowPassword onClick={handlePasswordClick} edge="end" />
      )}
    </div>
  );
};

const AccInfo = ({ GeneralInfo, photo }) => {
  const [CurrentAcc, setCurrentAcc] = useState(false);
  const user_profile = useSelector((state) => state.user);

  useEffect(() => {
    if (Object.keys(user_profile).length) {
      if (user_profile.current_account) {
        setCurrentAcc(user_profile.current_account);
      }
    }
  }, [user_profile]);

  return (
    <div className="Container-p-20 ProfileAccInfo">
      <Title six>General Information</Title>

      <div className="mbb-20 mtt-20 d-flex align-items-center gapp-10">
        <div>
          <img src={photo || ""} alt="" />
        </div>
        <div>
          {/* <div className='ProfileN'>{DataInfo && DataInfo.Account_Information && DataInfo.Account_Information.accountName}</div> */}
          <div className="ProfileN">
        
            {user_profile && user_profile.full_name && user_profile.full_name}
          </div>
          <div className="ProfileT">
            {GeneralInfo && GeneralInfo.status ? GeneralInfo.status : false}
          </div>
        </div>
      </div>
      <div>
        <Grid className="acccontainer">
          <Grid xs={12} md={4} className="AccInfoBox">
            {/* <HeadAndDesc
                            HeadTitle="Account number"
                            SubTitle={CopyFormatter(DataInfo && DataInfo.Account_Information && DataInfo.Account_Information.account)}
                            HeadAndSubClassName="Box"
                        /> */}
            <HeadAndDesc
              HeadTitle="Account number"
              SubTitle={CopyFormatter(CurrentAcc || false)}
              HeadAndSubClassName="Box"
              HeadTitleClass="input-acg"
            />
            <HeadAndDesc
              HeadTitle="starting balance"
              SubTitle={
                GeneralInfo &&
                GeneralInfo.challenge &&
                GeneralInfo.challenge.account_balance
                  ? dollarUS(GeneralInfo.challenge.account_balance)
                  : 0
              }
              HeadAndSubClassName="Box"
              HeadTitleClass="input-acg"
            />
            <HeadAndDesc
              HeadTitle="master password "
              SubTitle={PasswordFormatter(
                GeneralInfo &&
                  Object.keys(GeneralInfo).length &&
                  GeneralInfo.password
              )}
              HeadAndSubClassName="Box"
            />
            {/* <HeadAndDesc
              HeadTitle="Type"
              SubTitle={
                GeneralInfo &&
                Object.keys(GeneralInfo).length &&
                GeneralInfo.type
                  ? GeneralInfo.type
                  : "-"
              }
              HeadAndSubClassName="Box"
            /> */}
          </Grid>
          <Grid xs={12} sm={6} md={4} className="AccInfoBox">
            <HeadAndDesc
              HeadTitle="Account start date"
              SubTitle={
                GeneralInfo &&
                Object.keys(GeneralInfo).length &&
                GeneralInfo.start_date
                  ? formatDate(GeneralInfo.start_date)
                  : "-"
              }
              HeadAndSubClassName="Box"
            />
            <HeadAndDesc
              HeadTitle="Account expiry date"
              SubTitle={
                GeneralInfo &&
                Object.keys(GeneralInfo).length &&
                GeneralInfo.expiry_date
                  ? formatDate(GeneralInfo.expiry_date)
                  : "-"
              }
              HeadAndSubClassName="Box"
            />
            <HeadAndDesc
              HeadTitle="Leverage"
              SubTitle={
                GeneralInfo &&
                GeneralInfo.challenge &&
                GeneralInfo.challenge.Leverage
                  ? GeneralInfo.challenge.Leverage
                  : "-"
              }
              HeadAndSubClassName="Box"
            />
          </Grid>
          <Grid xs={12} sm={6} md={4} className="AccInfoBox">
            <HeadAndDesc
              HeadTitle="Broker"
              SubTitle={
                GeneralInfo &&
                GeneralInfo.challenge &&
                GeneralInfo.challenge.broker
                  ? GeneralInfo.challenge.broker
                  : "-"
              }
              HeadAndSubClassName="Box"
            />
            <HeadAndDesc
              HeadTitle="Server "
              // SubTitle={
              //   GeneralInfo &&
              //   Object.keys(GeneralInfo).length &&
              //   GeneralInfo.group &&
              //   GeneralInfo.group === "ACG\\Stage-1"
              //     ? "ACGMarkets-Live"
              //     : "ACGMarkets-Demo"
              // }
              SubTitle={
                GeneralInfo &&
                GeneralInfo.challenge &&
                GeneralInfo.challenge.server
                  ? GeneralInfo.challenge.server
                  : "-"
              }
              HeadAndSubClassName="Box"
            />
          </Grid>

          {/* <Grid xs={12} sm={6} md={2} className="AccInfoBox">
            <HeadAndDesc
              HeadTitle="Investor password"
              SubTitle={CopyFormatter(
                GeneralInfo &&
                  Object.keys(GeneralInfo).length &&
                  GeneralInfo.investor_password
              )}
              HeadAndSubClassName="Box"
            />
          </Grid> */}
          {/* <Grid xs={12} sm={6} md={4} className="AccInfoBox">
        
          </Grid> */}
          {/* <Grid xs={12} sm={6} md={2} className="AccInfoBox"></Grid> */}
        </Grid>
      </div>
    </div>
  );
};

export default AccInfo;
